import React from 'react';

import { Paragraph } from '@zillow/constellation';
import { SelectionGroup } from '@zillow/zrs-comet';

type Props = {
  disabled?: boolean;
  onOption1Click: () => void;
  option1Content?: string;
  option1Header?: string;
  option1Selected: boolean;

  onOption2Click: () => void;
  option2Content?: string;
  option2Header?: string;
  option2Selected: boolean;

  optionsText?: string;
};

export default function OptionSelector({
  disabled,
  onOption1Click,
  onOption2Click,
  option1Selected,
  option2Selected,
  option1Header,
  option2Header,
  option1Content,
  option2Content,
  optionsText,
}: Props): JSX.Element {
  return (
    <div>
      {optionsText && <Paragraph marginBottom="xs">{optionsText}</Paragraph>}
      <SelectionGroup>
        <SelectionGroup.Item disabled={disabled} onClick={onOption1Click} isSelected={option1Selected}>
          <SelectionGroup.Header>
            <Paragraph data-test="option1Header" fontType="bodyHeading" fontColor="">
              {option1Header}
            </Paragraph>
          </SelectionGroup.Header>
          <SelectionGroup.Content>
            <Paragraph data-test="option1Content" fontType="bodySmall" fontColor="">
              {option1Content}
            </Paragraph>
          </SelectionGroup.Content>
        </SelectionGroup.Item>
        <SelectionGroup.Item disabled={disabled} onClick={onOption2Click} isSelected={option2Selected}>
          <SelectionGroup.Header>
            <Paragraph data-test="option2Header" fontType="bodyHeading" fontColor="">
              {option2Header}
            </Paragraph>
          </SelectionGroup.Header>
          <SelectionGroup.Content>
            <Paragraph fontType="bodySmall" fontColor="" data-test="option2Content">
              {option2Content}
            </Paragraph>
          </SelectionGroup.Content>
        </SelectionGroup.Item>
      </SelectionGroup>
    </div>
  );
}

OptionSelector.defaultProps = {
  option1Header: `Tenant`,
  option1Content: `Responsible for account set up and direct payments to specified service provider`,
  option2Header: `Landlord`,
  option2Content: `Responsible for account set up and will bill tenant separately`,
};
